import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../../store";
import { Loader } from "../../../components/loader";
import { updateAdministereds } from "../../../actions/administered";
import { forceInputUppercase } from "../../../utils/helper";


const AdministeredType ={
  Vaccine : "vaccine",
  Treatment : "deworm"
};

const $ = window.$;
class EditAdministered extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            administered: "",
            oldAdministered: "",
            loading: false,
            inputNotValid: false,
            medicationInfo: {},

        };
    }
    handleChange = event => {
        forceInputUppercase(event);
        const value = event.target.value;
        this.setState({
            ...this.state,
            [event.target.name]: value
        });
    };

    submitAdministeredType(e) {
      e.preventDefault();       
        let data = {
            id : this.state.medicationInfo.id, 
            name: this.state.administered,
            type: this.state.medicationInfo.type
        };
        let valid = this.state.administered.length > 0;

        if (valid) {
            this.setState({ loading: true }); 
            this.props.updateAdministereds(data);
        } else {
            NotificationManager.warning("Administered data incomplete.");
        }
    }


    closeModal = () => {      ;
        let oldMedicationName = this.state.oldAdministered;
        this.setState({          
            loading: false,
            inputNotValid: false,
            administered: oldMedicationName
        });
        $("#edit_administered_type").modal("hide");
    };

    componentWillReceiveProps = nextProps => {   

        if( nextProps.treatmentData !== this.props.treatmentData){          
          this.setState({ medicationInfo : nextProps.treatmentData, administered: nextProps.treatmentData.name, oldAdministered: nextProps.treatmentData.name });
        }

        if(nextProps.updatedAdministered && nextProps.updatedAdministered !== this.props.updatedAdministered){
          NotificationManager.success("Administered type updated successfully");
          $("#edit_administered_type").modal("hide");
          this.setState({ loading: false });

        }
      
        if(nextProps.updatedAdministeredError !== this.props.updatedAdministeredError){ 
          const AdministeredTypeExists = "Administered type already exists";  
          this.setState({ loading : false, administered:"" }) 
          if(nextProps.updatedAdministeredError && nextProps.updatedAdministeredError.message === AdministeredTypeExists){
            NotificationManager.error(nextProps.updatedAdministeredError.message);            
          } 
          else{
            NotificationManager.error("Failed to edit Administered Type");
          }
               
        }
    }; 

    render() {
        const treatmentData = this.props.treatmentData;
        const { medicationInfo } = this.state;
        return (
          <div
            className="modal fade show"
            id="edit_administered_type"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <form className="m-form">
                  <div className="modal-header">
                    {treatmentData.type === AdministeredType.Vaccine ? (
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit Vaccination Type
                      </h5>
                    ) : treatmentData.type === AdministeredType.Treatment ? (
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit Treatment Type
                      </h5>
                    ) : null}
    
                    <button
                      type="button"
                      className="close"
                      onClick={this.closeModal}
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="m-form__section m-form__section--first">                     
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">
                              {treatmentData.type === AdministeredType.Vaccine
                                ? "Vaccination"
                                : treatmentData.type === AdministeredType.Treatment
                                ? "Treatment"
                                : null}{" "}
                              Type:
                            </label>
                            <div className="col-xl-9 col-lg-9">
                              <input
                                type="text"
                                name="administered"
                                onChange={e => this.handleChange(e)}
                                value={this.state.administered}
                                className="form-control m-input"
                                placeholder=""
                              />
                              <span
                                className={
                                  this.state.inputNotValid
                                    ? "m-form__help_danger"
                                    : "m-form__help"
                                }
                              >
                                Please enter{" "}
                                {treatmentData.type === AdministeredType.Vaccine
                                  ? "vaccination"
                                  :treatmentData.type === AdministeredType.Treatment
                                  ? "treatment"
                                  : null}{" "}
                                type
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    {this.state.loading == false ? (
                      <div>
                        <button
                          type="button"
                          className="btn btn-secondary m-btn--pill mx-2"
                          onClick={this.closeModal}
                        >
                          Close
                        </button>
                        <button
                          onClick={(e) => this.submitAdministeredType(e)}
                          type="submit"
                          className="btn btn-primary m-btn--pill"
                        >
                          Submit
                        </button>
                      </div>
                    ) : (
                      <div className="center-row">
                        <Loader size={50} />
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        );
      }
    }
    
    const mapStateToProps = state => ({
      administered: state.administeredTypeReducer.setAdministered,
      administeredError: state.administeredTypeReducer.setAdministeredError,
      updatedAdministered: state.administeredTypeReducer.updatedAdministered,
      updatedAdministeredError: state.administeredTypeReducer.updatedAdministeredError
    });
    
    const mapDispatchToProps = dispatch => ({
      updateAdministereds: vaccine => {
        dispatch(updateAdministereds(vaccine));
      }
    });
    
    export default withRouter(
      connect(mapStateToProps, mapDispatchToProps)(EditAdministered)
    );
